// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"a3c23474","496":"48ee6cd8","960":"66c9c04c"}[chunkId] + ".chunk.js";
};